import { defineMessages } from 'react-intl';

export default defineMessages({
    completingYourPurchaseMessage: {
        id: 'renewal.eu.renewalChangeDiffPage.Completing your purchase...',
        defaultMessage: 'Completing your purchase...'
    },
    loadingPolicyDiff: {
        id: 'renewal.eu.renewalChangeDiffPage.Loading...',
        defaultMessage: 'Loading...'
    },
    changesPhrases: {
        id: 'renewal.eu.policyDiffPage.Change Phrases',
        defaultMessage: 'Change Phrases'
    },
    issue: {
        id: 'renewal.eu.policyDiffPage.Issue',
        defaultMessage: 'Issue'
    },
    bindError: {
        id: 'renewal.eu.config.Unable to bind change',
        defaultMessage: 'Unable to bind change'
    },
    bindErrorMessage: {
        id: 'renewal.eu.config.An error occurred while attempting to bind changes',
        defaultMessage: 'An error occurred while attempting to bind changes'
    },
    changeConflict: {
        id: 'renewal.eu.renewalChangeDiffPage.tab.Change Conflicts',
        defaultMessage: 'Change Conflicts'
    },
    signature: {
        id: 'renewal.eu.renewalChangeDiffPage.tab.Signature',
        defaultMessage: 'Signature'
    },
    differencesTab: {
        id: 'renewal.eu.renewalChangeDiffPage.tab.Differences',
        defaultMessage: 'Differences'
    },
    noDataText: {
        id: 'renewal.eu.policyDiffPage.No Change Phrases',
        defaultMessage: 'No Change Phrases'
    }
});
